import React, { Component } from 'react'
import _ from 'lodash'
import App from './app'

import './css/style.css'
import { constants } from './constants/constants'
import { apiConstants } from './constants/apiConstants'

import { removeExtraSlashes, isCorpOrGoPayUser } from './helper'
import { shareConstants } from './constants/shareConstants'
import ErrorPage404 from '../src/screens/ErrorPage404'

class Navigate extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      authStateLoaded: false,
      isUserLoggedIn: false,
      isPageNotFound: false,
    }
  }

  componentDidMount() {
    const isUser = this.props.userData && !!this.props.userData.email
    if (isUser) {
      this.updateUser(this.props.userData)
      this.updateState(isUser, true)
    } else {
      this.updateState(false, true)
    }
  }

  updateUser(userData) {
    const userDetails = _.pick(userData, constants.UserKeys)
    this.props.actions.setUserPermissionForFolder(
      isCorpOrGoPayUser(userDetails)
        ? shareConstants.FilePermissions.readWriteExecute
        : shareConstants.FilePermissions.readWrite,
    )
    this.props.actions.setUser(userDetails)
  }

  updateState = (isUserLoggedIn, authStateLoaded) => {
    this.setState({ isUserLoggedIn, authStateLoaded })
  }

  loginCorp = () => {
    window.location.href = `${apiConstants.URLPrefix}${apiConstants.Login}`
  }

  loginUL = () => {
    const _path = removeExtraSlashes(
      this.props.location.pathname.replace(apiConstants.URLPrefix, ''),
    )
    window.location.href = `${this.props.ulSignin}`
  }

  renderLogin = () => {
    const { requestURL } = this.props
    const location = window.location.hostname.replace(/^(www\.)/, '')
    if (_.includes(requestURL.internal, location)) {
      this.loginCorp()
      return
    }
    if (_.includes(requestURL.external, location)) {
      this.loginUL()
      return
    }
    this.setState({ isPageNotFound: true })
  }

  renderApp = (isUserLoggedIn) => {
    const { isSSOEnabled } = this.props
    isUserLoggedIn = isSSOEnabled ? isUserLoggedIn : !isSSOEnabled
    return isUserLoggedIn ? <App {...this.props} /> : this.renderLogin()
  }

  renderLandingPage = () => {
    const { authStateLoaded, isUserLoggedIn } = this.state
    return authStateLoaded ? (
      this.renderApp(isUserLoggedIn)
    ) : (
      <div className="loader" />
    )
  }

  render() {
    const { isPageNotFound } = this.state
    return (
      <div className="app_navigate">
        {isPageNotFound ? <ErrorPage404 /> : this.renderLandingPage()}
      </div>
    )
  }
}

export default Navigate
